import * as _ from 'lodash-es';
import React from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import { UIActions } from '../ui/uiSlice';
import SidebarRow, { SidebarRowRightContent } from './SidebarRow';
import * as styles from './SidebarSection.module.scss';
import SidebarSectionAnimation from './SidebarSectionAnimation';

interface SidebarSectionProps {
  children?: React.ReactNode;
  id: string;
  title: string;
  collapsedByDefault?: boolean;
  icon?: React.ReactNode;
  menuItems?: React.ReactNode;
  customMenu?: React.ReactNode;
  publicVariant?: boolean;
  hasChildren: boolean;
}

const SidebarSection = ({
  children,
  id,
  title,
  menuItems,
  icon,
  customMenu,
  collapsedByDefault,
  publicVariant,
  hasChildren,
}: SidebarSectionProps) => {
  const dispatch = useAppDispatch();
  const collapsedSidebarSections = useAppSelector(
    (state) => state.ui.collapsedSidebarSections,
  );

  const isExpanded =
    id in collapsedSidebarSections
      ? !collapsedSidebarSections[id]
      : !collapsedByDefault;

  const handleExpandClick: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(
      UIActions.toggleSidebarSection({
        section: id,
        isInitiallyCollapsed: !!collapsedByDefault,
      }),
    );
  };

  const getExpandState = () => {
    if (!hasChildren) return 'none';
    return isExpanded ? 'expanded' : 'collapsed';
  };

  return (
    <div className={styles.container} aria-label={_.startCase(title)}>
      <div>
        <SidebarRow
          level={0}
          icon={icon}
          onClick={handleExpandClick}
          menuItems={menuItems}
          publicVariant={publicVariant}
          rightContent={
            <SidebarRowRightContent
              customMenu={customMenu}
              expandState={getExpandState()}
              onExpandClick={handleExpandClick}
            />
          }
        >
          {title}
        </SidebarRow>
      </div>
      <SidebarSectionAnimation sectionKey={id} expanded={isExpanded}>
        {children}
      </SidebarSectionAnimation>
    </div>
  );
};

export default SidebarSection;
